module.exports = __webpack_public_path__ + "img/manage.34bf9e6b.svg";